import {
  LOGIN_USER,
  LOGOUT_USER
} from 'stores/types/';

const auth = ( state = {}, action ) => {
  switch( action.type ) {
    case LOGIN_USER:
      return {
        ...state,
        ...action.data
      };
    case LOGOUT_USER:
      return {};
    default:
      return state;
  }
};

module.exports = auth;



// WEBPACK FOOTER //
// ./stores/reducers/common/user.js